import * as Yup from 'yup';
import { checkISBNExists } from './bookUtils';

Yup.addMethod(Yup.string, "ISBN", function (message) {
  return this.test(`ISBN`, message, async function () {
    // Return false if the validation doesn't meet te requirements.
    const isbn = this.from[0].value.isbn13;
    if (isbn == undefined) return true; // isbn is not present.

    const bookExists = await checkISBNExists(isbn);
    return !bookExists;
  })
})

const getBookKeys = (lang) => {

  const bookKeys = {
    "Fecha Creación": {
      id: "creation_date",
      required: true,
      placeholder: "",
      type: "date",
      validations:
        [{
          type: "date",
          params: [lang.book.validation.date]
        }
        ],
      zeroValue: ""
    },
    "SIIEL SKU": {
      id: "sieel_sku",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "BW SKU": {
      id: "bw_sku",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Estado": {
      id: "active",
      required: true,
      placeholder: "",
      type: "checkbox",
      zeroValue: false
    },
    "URL de acceso abierto": {
      id: "open_access_url",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Formato": {
      id: "file_format",
      required: false,
      placeholder: "epub | pdf | txt",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Detalle formato": {
      id: "format_details",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Editorial": {
      id: "editorial",
      required: true,
      placeholder: "Programa Editorial Universidad del Valle",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Portada": {
      id: "cover_image",
      required: false,
      placeholder: "", // Here should be some preloaded image for any book.
      type: "file",
      zeroValue: ""
    },
    "ISBN13": {
      id: "isbn13",
      required: true,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        },
        {
          type: "ISBN",
          params: [lang.book.validation.ISBN]
        }
        ],
      zeroValue: ""
    },
    "DOI": {
      id: "doi",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Título": {
      id: "title",
      required: true,
      placeholder: "Las aventuras de Tom Sawyer",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Subtítulo": {
      id: "subtitle",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Autor / autores": {
      id: "collaborators",
      required: true,
      placeholder: lang.book.placeholder.collaborators,
      type: "select-look",
      validations:
        [{
          type: "array",
          params: [""]
        },
        {
          type: "min",
          params: [1, lang.book.validation.min_author]
        }
        ],
      zeroValue: []
    },
    "BISAC": {
      id: "bisac",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "THEMA": {
      id: "thema",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Personalizada": {
      id: "customized",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Palabras clave": {
      id: "keywords",
      required: false,
      placeholder: lang.book.placeholder.keywords,
      type: "select-create",
      validations:
        [{
          type: "array",
          params: [""]
        }
        ],
      zeroValue: []
    },
    "Ilustrado?": {
      id: "has_ilustrations",
      required: false,
      placeholder: "",
      type: "checkbox",
      zeroValue: false
    },
    "Audiencia": {
      id: "audience",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Tipo de contenido primario": {
      id: "primary_content_type",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Dimensiones físicas": {
      id: "physic_dimentions",
      required: false,
      placeholder: "10cm x 15 cm x 5cm",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Peso": {
      id: "weight",
      required: false,
      placeholder: "0.1 kg",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Colección": {
      id: "colection",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Número de edición": {
      id: "edition_number",
      required: false,
      placeholder: "",
      type: "number",
      validations:
        [{
          type: "number",
          params: [lang.book.validation.number]
        },
        {
          type: "positive",
          params: [lang.book.validation.positive]
        },
        {
          type: "integer",
          params: [lang.book.validation.positive_integer]
        }
        ],
      zeroValue: 1
    },
    "Idioma": {
      id: "language",
      required: false,
      placeholder: "English",
      type: "text", // TODO could has more than 1 language?
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Número de páginas": {
      id: "pages",
      required: false,
      placeholder: "1365",
      type: "number",
      validations:
        [{
          type: "number",
          params: [lang.book.validation.number]
        },
        {
          type: "positive",
          params: [lang.book.validation.positive]
        },
        {
          type: "integer",
          params: [lang.book.validation.positive_integer]
        }
        ],
      zeroValue: 321
    },
    "Ciudad de publicación": {
      id: "publication_city",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "País de publicación": {
      id: "publication_country",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Año de publicación": {
      id: "edition_year",
      required: false,
      placeholder: "2007",
      type: "number",
      validations:
        [{
          type: "number",
          params: [lang.book.validation.number]
        },
        {
          type: "integer",
          params: [lang.book.validation.integer]
        }
        ],
      zeroValue: 2000
    },
    "Derechos de venta": {
      id: "selling_rights",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Restricciones de venta": {
      id: "selling_constraints",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Mercado": {
      id: "market",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    },
    "Precio": {
      id: "price",
      required: false,
      placeholder: "1000000",
      type: "number",
      validations:
        [{
          type: "number",
          params: [lang.book.validation.number]
        },
        {
          type: "min",
          params: [0, lang.book.validation.natural]
        }
        ],
      zeroValue: 0
    },
    "Resumen": {
      id: "summary",
      required: false,
      placeholder: "",
      type: "text",
      validations:
        [{
          type: "string",
          params: [""]
        }
        ],
      zeroValue: ""
    }
  }

  let translatedBookKeys = {};
  for (let key in bookKeys) {
    let object = bookKeys[key];
    translatedBookKeys[lang.book[object.id]] = object;
  }

  return translatedBookKeys;
}

export { getBookKeys }